import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect y={4} width={32} height={24} rx={4} fill="white" />
    <rect
      x={0.5}
      y={4.5}
      width={31}
      height={23}
      rx={3.5}
      stroke="#161C24"
      strokeOpacity={0.1}
    />
    <path
      d="M21.3333 17.3333H23.1396C23.1913 17.3333 23.3117 17.3195 23.3633 17.3195C23.7075 17.2639 23.9999 17.0139 23.9999 16.6667C23.9999 16.3334 23.7075 16.0833 23.3633 16.0139C23.3117 16 23.2085 16 23.1397 16H21.3334V17.3333H21.3333Z"
      fill="url(#paint0_linear_3803_53589)"
    />
    <path
      d="M23.2606 8C21.4788 8 20.0178 9.27286 20.0178 10.8598V12.6867H24.5969C24.7038 12.6867 24.8285 12.6867 24.9175 12.7024C25.9509 12.7496 26.7171 13.2209 26.7171 14.0379C26.7171 14.6822 26.2004 15.2322 25.2383 15.3422V15.3735C26.2894 15.4364 27.0913 15.9549 27.0913 16.7563C27.0913 17.6205 26.2004 18.1862 25.0244 18.1862H20V24H24.7572C26.5389 24 28 22.7272 28 21.1402V8H23.2606Z"
      fill="url(#paint1_linear_3803_53589)"
    />
    <path
      d="M23.9998 14C23.9998 13.6363 23.6806 13.3939 23.305 13.3484C23.2675 13.3484 23.1736 13.3333 23.1173 13.3333H21.3333V14.6666H23.1173C23.1737 14.6666 23.2862 14.6666 23.3051 14.6515C23.6807 14.606 23.9999 14.3636 23.9999 13.9999L23.9998 14Z"
      fill="url(#paint2_linear_3803_53589)"
    />
    <path
      d="M7.26058 8C5.47885 8 4.01776 9.27403 4.01776 10.8625V16.7813C4.9265 17.1743 5.87077 17.426 6.81514 17.426C7.9376 17.426 8.54335 16.8284 8.54335 16.0106V12.6763H11.3229V15.9948C11.3229 17.2844 10.4142 18.3382 7.33185 18.3382C5.46109 18.3382 4 17.9764 4 17.9764V24H8.75719C10.5389 24 12 22.7261 12 21.1375V8.0002L7.26058 8Z"
      fill="url(#paint3_linear_3803_53589)"
    />
    <path
      d="M15.4951 8C14.3073 8 13.3333 9.2717 13.3333 10.8572V13.4506C13.8797 12.8383 14.8299 12.4459 16.3622 12.5401C17.1818 12.5872 18.0608 12.8855 18.0608 12.8855V14.0943C17.6212 13.796 17.0987 13.529 16.4216 13.4662C15.2575 13.3564 14.5567 14.1099 14.5567 15.4286C14.5567 16.763 15.2575 17.5165 16.4216 17.3909C17.0987 17.3281 17.6213 17.0456 18.0608 16.763V17.9718C18.0608 17.9718 17.1937 18.27 16.3622 18.3172C14.8299 18.4113 13.8797 18.0188 13.3333 17.4066V24H16.5048C17.6926 24 18.6666 22.7284 18.6666 21.1428V8.0002L15.4951 8Z"
      fill="url(#paint4_linear_3803_53589)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3803_53589"
        x1={19.7992}
        y1={16.6683}
        x2={27.5303}
        y2={16.6683}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#007940" />
        <stop offset={0.2285} stopColor="#00873F" />
        <stop offset={0.7433} stopColor="#40A737" />
        <stop offset={1} stopColor="#5CB531" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3803_53589"
        x1={20.0146}
        y1={15.4217}
        x2={28.0218}
        y2={15.4217}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={1} stopColor="#5CB531" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3803_53589"
        x1={19.6585}
        y1={13.998}
        x2={28.0978}
        y2={13.998}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#007940" />
        <stop offset={0.2285} stopColor="#00873F" />
        <stop offset={0.7433} stopColor="#40A737" />
        <stop offset={1} stopColor="#5CB531" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3803_53589"
        x1={4.01408}
        y1={15.4296}
        x2={12.1446}
        y2={15.4296}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={1} stopColor="#006FBC" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3803_53589"
        x1={13.3025}
        y1={15.4138}
        x2={18.567}
        y2={15.4138}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={1} stopColor="#E60039" />
      </linearGradient>
    </defs>
  </svg>
);
export default SVGComponent;
